import BaseService from '@/services/BaseService';

class SupplierService extends BaseService {
    getAll = (filters) => this.post('/agency/service/share/list', filters || { });

    sendServiceRequest = (data) => this.post('/agency/sendServiceRequest', data);
}
export default new SupplierService();
